"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectDebitGuarantee = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../../../shared/core");
var analytics_subjects_1 = require("../../../../../../analytics-subjects");
var copy_1 = require("../../../../../../copy");
var SetupDirectDebit_styled_1 = require("../SetupDirectDebit.styled");
var DirectDebitGuarantee = function (_a) {
    var _b;
    var value = _a.value, error = _a.error, handler = _a.handler;
    var _c = (0, core_1.useComponents)(), Checkbox = _c.Checkbox, Card = _c.Card, Heading3 = _c.Heading3;
    var _d = (0, core_1.useCopy)(copy_1.defaultOptions), copy = _d.copy, Copy = _d.Copy;
    var retailer = 'OVO';
    var numberOfWorkingDays = 3;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Card, null,
            react_1.default.createElement(SetupDirectDebit_styled_1.StyledDirectDebitHeader, null,
                react_1.default.createElement(Heading3, null,
                    react_1.default.createElement(Copy, { copyKey: "setupDirectDebitGuaranteeHeading" })),
                react_1.default.createElement(SetupDirectDebit_styled_1.StyledDirectDebitLogo, null)),
            react_1.default.createElement(Copy, { copyKey: "setupDirectDebitGuaranteeBody", values: { retailer: retailer, numberOfWorkingDays: numberOfWorkingDays } })),
        react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.SETUP_DD_GUARANTEE, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
            react_1.default.createElement(Checkbox, { id: "ddGuaranteeAccepted", label: copy('setupDirectDebitGuaranteeLabel'), checked: value, onChange: handler, error: error }))));
};
exports.DirectDebitGuarantee = DirectDebitGuarantee;
